import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ShieldCheck, UserCheck, Search, Car, Sparkles, ClipboardCheck, ArrowRight, Navigation, Building2, Truck, Video } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Seo } from '../components/academy/Seo';
import BrandHero from '../components/BrandHero';
import { SERVICES } from '../data/services';

const ICONS = { ShieldCheck, UserCheck, Search, Car, Sparkles, ClipboardCheck, Navigation, Building2, Truck, Video };

const ServicesIndex = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
  ];

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #0e0e10 0%, #17171a 55%, #0e0e10 100%)' }}>
      <Seo
        siteName="CarLens"
        title="Inspection Services · Northeast Florida"
        description="Explore CarLens vehicle inspection services in NE Florida: pre-purchase, private seller, Facebook Marketplace, dealer lot, FirstLook remote analysis, post-purchase, mobile, dealer acquisition, and fleet inspections."
        path="/services"
        breadcrumbs={breadcrumbs}
      />
      <BrandHero />
      <div className="max-w-5xl mx-auto px-5 py-12 md:py-16">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight" style={{ fontFamily: 'Space Grotesk' }} data-testid="services-h1">
          CarLens Inspection Services
        </h1>
        <p className="mt-5 text-lg leading-8 text-zinc-300 max-w-2xl">
          Independent, mobile, buyer-first. Whatever you’re buying and wherever you found it, CarLens gives you the truth before you commit. <span className="text-white font-semibold">Inspect. Inform. Protect.</span>
        </p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon] || ShieldCheck;
            return (
              <Link key={s.slug} to={`/services/${s.slug}`} className="group rounded-2xl border border-zinc-800 bg-[#161618] p-6 hover:border-orange-500/50 transition-colors" data-testid={`services-card-${s.slug}`}>
                <Icon className="w-7 h-7 text-orange-400 mb-3" />
                <h2 className="text-lg font-bold text-white group-hover:text-orange-300 transition-colors" style={{ fontFamily: 'Space Grotesk' }}>{s.name}</h2>
                <p className="text-sm text-zinc-400 mt-1.5 leading-6">{s.tagline}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-orange-400">Learn more <ArrowRight className="w-3.5 h-3.5" /></span>
              </Link>
            );
          })}
        </div>

        <div className="mt-12 rounded-3xl bg-gradient-to-br from-orange-500 to-orange-600 p-8 sm:p-10 text-center">
          <h3 className="text-2xl sm:text-3xl font-extrabold text-white" style={{ fontFamily: 'Space Grotesk' }}>Know the truth before you buy.</h3>
          <p className="mt-2 text-orange-50">Book your independent CarLens inspection today.</p>
          <Button onClick={() => navigate('/book')} className="mt-6 rounded-full bg-white text-orange-600 hover:bg-orange-50 px-8 py-5 h-auto text-base font-semibold" data-testid="services-book-btn">
            Book Your Inspection <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServicesIndex;
